import autobind from 'autobind-decorator';
import * as React from 'react';
import { connect } from 'react-redux';
import { AnyAction, Dispatch } from 'redux';
import { IconButton, Icons, Switcher, Text } from '@shared/ui-components';

import { PaymentConstants } from 'common/constants/payment';
import { KreoDialogActions } from 'common/UIKit';
import { BillingPeriodUnit } from '../../../../../../units/subscription/enums/billing-period-unit';
import { SubscriptionAddon } from '../../../../interfaces/subscription-addon';
import { AddonAdvDialogName } from '../addon-list';
import { AddonAdvDialogs } from './addon-adv-dialogs';
import { Styled } from './styled';

interface DispatchProps {
  openAdvDialog: () => void;
}

interface OwnProps {
  addon: SubscriptionAddon;
  isSelected: boolean;
  isTeamPlan: boolean;
  advDialogName: AddonAdvDialogName;
  toggleSelection: (id: string, isSelected: boolean) => void;
  billingPeriod: BillingPeriodUnit;
}

interface Props extends DispatchProps, OwnProps {}

class AddonComponent extends React.Component<Props> {
  public render(): JSX.Element {
    const { addon, isSelected, openAdvDialog, advDialogName } = this.props;

    return (
      <Styled.AddonItem key={addon.id}>
        <Styled.AddonGroupName>
          <Switcher
            checked={isSelected}
            onChange={this.toggleSelection}
            size='l'
          />
          <Text fontSize={16} color='mainFont'>{addon.groupName}</Text>
        </Styled.AddonGroupName>
        <Styled.CostAddonAndIconButtonWrapper>
          <Styled.CostAddon>
            <Text fontSize={12} color='mainFont'>{this.getBillingPricing()}</Text>
          </Styled.CostAddon>
          {advDialogName &&
            <Styled.AdvDialogButton>
              <IconButton
                Icon={Icons.Question}
                onClick={openAdvDialog}
                height={40}
              />
              <AddonAdvDialogs
                dialogName={advDialogName}
                onConfirm={this.onConfirm}
              />
            </Styled.AdvDialogButton>
          }
        </Styled.CostAddonAndIconButtonWrapper>
      </Styled.AddonItem>
    );
  }

  @autobind
  private toggleSelection(): void {
    const { addon, isSelected } = this.props;
    this.props.toggleSelection(addon.id, !isSelected);
  }

  @autobind
  private onConfirm(): void {
    this.props.toggleSelection(this.props.addon.id, true);
  }

  @autobind
  private getBillingPricing(): string {
    const { isTeamPlan, addon, billingPeriod } = this.props;
    const priceMonth = addon.price / 100;
    const priceYear = Math.ceil(addon.price / 100 / 12);
    const price = billingPeriod === BillingPeriodUnit.Year ? priceYear : priceMonth;
    const perUser = isTeamPlan ? 'per user, per month' : 'per month';
    const billingPricing = `+ ${PaymentConstants.defaultCurrency} ${price} ${perUser}`;
    return billingPricing;
  }
}


function mapDispatchToProps(dispatch: Dispatch<AnyAction>, ownProps: OwnProps): DispatchProps {
  return {
    openAdvDialog: () => dispatch(KreoDialogActions.openDialog(ownProps.advDialogName)),
  };
}

export const Addon = connect(null, mapDispatchToProps)(AddonComponent);
